export enum TPlayabilityStatus {
  UnplayableOtherReason = 'UnplayableOtherReason',
  Playable = 'Playable',
  GuestProhibited = 'GuestProhibited',
  GameUnapproved = 'GameUnapproved',
  IncorrectConfiguration = 'IncorrectConfiguration',
  UniverseRootPlaceIsPrivate = 'UniverseRootPlaceIsPrivate',
  InsufficientPermissionFriendsOnly = 'InsufficientPermissionFriendsOnly',
  InsufficientPermissionGroupOnly = 'InsufficientPermissionGroupOnly',
  DeviceRestricted = 'DeviceRestricted',
  UnderReview = 'UnderReview',
  PurchaseRequired = 'PurchaseRequired',
  AccountRestricted = 'AccountRestricted',
  TemporarilyUnavailable = 'TemporarilyUnavailable'
}

export type TGetProductDetails = {
  placeId: number;
  name: string;
  description: string;
  url: string;
  builder: string;
  builderId: number;
  isPlayable: boolean;
  reasonProhibited: string;
  universeId: number;
  universeRootPlaceId: number;
  price: number;
  imageToken: string;
};

export type TGetProductInfo = {
  universeId: number;
  isForSale: boolean;
  productId: number;
  price: number;
  sellerId: number;
};

export type TGetPlayabilityStatus = {
  playabilityStatus: TPlayabilityStatus;
  isPlayable: boolean;
  universeId: number;
};

export type TLoadingComponent = () => JSX.Element;
export type TErrorComponent = (
  status: Exclude<
    TPlayabilityStatus,
    | TPlayabilityStatus.Playable
    | TPlayabilityStatus.GuestProhibited
    | TPlayabilityStatus.PurchaseRequired
  >
) => JSX.Element;
export type TPurchaseComponent = (
  productDetails: TGetProductDetails,
  productInfo: TGetProductInfo
) => JSX.Element;
export type TPlayComponent = (
  status: TPlayabilityStatus.Playable | TPlayabilityStatus.GuestProhibited
) => JSX.Element;
